export default "__VITE_ASSET__DfepGXqI__"